'use strict';
import util from './util';
import bonusProductsView from './bonus-products-view';
import samples from './samples';
import currentLayout from './detect-layout';
import analytics from './analytics';
import customDropdown from './custom-dropdown';
import ajax from './ajax';
import analyticsEmea from './analyticsBase';

let checkLayout = currentLayout.init();

$(window).on('resize', function() {
	checkLayout = currentLayout.init();
});

var timer = {
	id: null,
	clear: function () {
		if (this.id) {
			window.clearTimeout(this.id);
			delete this.id;
		}
	},
	start: function (duration, callback) {
		this.id = setTimeout(callback, duration);
	}
};
var timeoutid = 0;
var minicart = {
	init: function () {
		this.$el = $('#mini-cart');
		this.$elMobile = $('#mini-cart-mobile');
		this.$content = this.$el.find('.mini-cart-content');

		// events
		this.$el.find('.mini-cart-total').on('mouseenter', function () {
			if (this.$content.not(':visible')) {
				this.slide();
			}
		}.bind(this));

		this.$content.on('mouseenter', function () {
			timer.clear();
		}).on('mouseleave', function () {
			timer.clear();
		}.bind(this));
	},

	addProduct: function (data) {
		var show = this.show.bind(this);
		
		return new Promise(function (resolve, reject) {
			if (data.hasOwnProperty("pid") === false) {
				return reject();
			}

			$.post(util.appendParamsToUrl(Urls.addProduct, {
				"format": "ajax",
				"pid": encodeURIComponent(data.pid),
				"Quantity": data.hasOwnProperty("Quantity") ? data.Quantity : "1"
			}), function (data) {
				if (data.success === false) {
					return reject(data.error);
				}

				show(data);
				attachPromotionClickHandler();
				minicartRecommendations();
				resolve();
			}).fail(function (err) {
				reject(err.error);
			});
		});
	},

	updateProduct: function (data) {
		$('.mini-cart-products .ajax-loader').show();
		return new Promise(function (resolve, reject) {
			$.post(util.appendParamsToUrl(data.dataRedirectUrl, {
				"format": "ajax",
				"pid": encodeURIComponent(data.pid),
				"Quantity": data.hasOwnProperty("Quantity") ? data.Quantity : "1"
			}), function (data) {
				if (data.success === false) {
					return reject(data.error);
				}
				if (data) {
					$('.minicart').parent('li').html(data);
					$('.minicart-link .minicart').addClass('qtyopenedupdate');
					$('select.minicart-quantity-dropdown').selectmenu();
					util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
					minicartCartIconRedirect();
					updateQuantityOnChange();
					minicartRecommendations();
					attachPromotionClickHandler();
					$('.minicart-link .sb-container').scrollBox();
				}
				resolve();
			}).fail(function (err) {
				reject(err.error);
			});
		});
	},

	addAllToWishlistFromContent: function (pids) {
		return window.location.href = Urls.addAllFromContent
			+ "?pid=" + pids.join(":1,") // pass qty of one
			+ "&cid=" + window.contentAssetID
			+ "&hashparam=" + window.location.hash.split('#')[1];
	},

	addAllProducts: function (pids, to, checkIfRoutine) {
		if (!pids || pids.length === 0) {
			return;
		}

		var isWishlist = (to && to.toLowerCase() === "wishlist");
		if (isWishlist && !window.User.isCustomerAuthenticated) {
			if (window.contentAssetID) {
				return this.addAllToWishlistFromContent(pids);
			} else {
				var footerURL = $('footer') ? $('footer').data('url') : null;
				window.location = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
				return;
			}
		}

		var show = this.show.bind(this);
		var urlName = Urls.addMultipleProducts;

		if (isWishlist) {
			urlName = Urls.wishlistAddAll.split(window.location.hostname)[1];
		}

		$.post(util.appendParamsToUrl(urlName, {
			format: 'ajax',
			pid: pids
		}), function (data) {
			if (isWishlist) {
				window.location.href = window.location.href;
				return;
			}

			if (data) {
				if(checkIfRoutine) {
					show(data, "", true);
					const availableCount = $('.routine-product-wrapper:not(.oos-routine-product)').length;
				
					const addedCount = $('.routine-product-wrapper')
						.not('.oos-routine-product')
						.filter('.r-main-product-added, .selected-routine-product')
						.length;
					if (availableCount === addedCount) {
						$("#minicart").removeAttr('style').addClass("opened");
						crosssellRecommendationModalHandler();
					}
					$('html').removeClass('filter-open modal-open');
					getCumulativeDiscounts();
				} else {
					show(data);
					if (checkLayout == 'mobile') {
						$("#minicart").removeAttr('style').addClass("opened");
						crosssellRecommendationModalHandler();
					} else {
						$("#minicart").removeAttr('style').addClass("opened");
						crosssellRecommendationModalHandler();
					}
				}
			}
		});
	},

	/**
	 * @function
	 * @description Shows the given content in the mini cart
	 * @param {String} A HTML string with the content which will be shown
	 */
	show: function (html, disabledConfirmation, checkRoutine) {
		$('.quick-shop-panel').hide();

		const $header = $('.header-wrapper');
		const $topWrapper = $('.top-wrapper');
		const currentPosition = $header.css('position');
		const headerHeight = $header.height() + 'px';
		const timeout = 5000;

		// Temporarily fix header
		if (currentPosition !== 'fixed') {
			$header.css('position', 'fixed');
			$topWrapper.css('padding-bottom', headerHeight);
		}

		// Update minicart HTML
		if (html && $('.minicart-link').length) {
			$('.minicart-link.desktop-only, .minicart-link.mobile-only').html(html);

			if (!disabledConfirmation) {
				if (checkLayout === 'mobile') {
					$('.minicart-link.mobile-only').find('.mini-cart-content').remove();
					$('body').addClass('add-to-confirmation');
				}
				if ($('.add-cart-confirmation-product>div').length) {
					$('.minicart').addClass('confirmation-active');
				}
			}

			setTimeout(() => {
				$('.minicart-link .sb-container').scrollBox();
			}, 1000);
		}

		// Reset header styles after timeout
		setTimeout(() => {
			if ($header.length || $topWrapper.length) {
				$header.css('position', currentPosition);
				$topWrapper.removeAttr('style');
			}
		}, timeout);

		// Check if samples can be shown
		let canShowSamples = false;
		$('#minicart input[name="eligible-for-sample"]').each(function () {
			if ($(this).val() === 'true') canShowSamples = true;
		});

		if ($('.pt_cart').length) { // Only for Cart-Checkout
			if (!bonusProductsView.hasBonusOptions() && samples.canShowSelection() && canShowSamples) {
				samples.showSelection();
			}
			bonusProductsView.loadBonusOption();
		}

		// Initialize UI elements
		$('select.minicart-quantity-dropdown').selectmenu();
		attachPromotionClickHandler();
		updateQuantityOnChange();
		util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
		minicartCartIconRedirect();

		// Wait until sb-container content exists
		util.waitForElement('.minicart-link .sb-container .sb-content')
			.then(() => {
				$('.minicart-link .sb-container .sb-content').removeAttr('style');
				$(window).trigger('resize.scrollBox');
				if(checkRoutine) {
					return;
				} else {
					$('html').addClass('modal-open');
				}

				// Wait for minicart recommendations (Slick) to initialize
				return minicartRecommendations();
			})
			.then(($recommendations) => {
				// Wait for truly visible slides
				return util.getTrulyVisibleSlides($('.minicart-recommendation-container'));
			})
			.then(() => {
				// Trigger analytics after slides are visible
				analytics.minicartCrossSellProductList();
			})
			.catch((err) => {
				console.warn('Minicart show error:', err);
			});

		// Fire main analytics immediately
		analyticsEmea.minicartProductList();
	},

	/**
	 * @function
	 * @description Slides down and show the contents of the mini cart
	 */
	slide: function () {
		// show the item
		this.$content.slideDown('slow');
		this.$content.attr('aria-expanded', true);
		$('select.minicart-quantity-dropdown').selectmenu();
	},
	/**
	 * @function
	 * @description Closes the mini cart with given delay
	 * @param {Number} delay The delay in milliseconds
	 */
	close: function (delay) {
		$('.minicart').removeClass('confirmation-active');
		$('body').removeClass('add-to-confirmation')
		$('.minicart').removeClass('opened').addClass('closed');
		$('.crosssell-recommendation-modal').removeClass('active');
		$('html').removeClass('filter-open');
	},
	remove: function (pid, checkIfRoutine) {
		$('.mini-cart-products .ajax-loader').show();
		$.post(util.appendParamsToUrl(Urls.removeMiniCartLineItem, {
			"format": "ajax",
			"pid": pid
		}), function (data) {
			if (data) {
				$('.minicart').parent('li').html(data);
				if($('.minicart-link .minicart').length){
					attachPromotionClickHandler();
					util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
					minicartCartIconRedirect();
					updateQuantityOnChange();
					minicartRecommendations();
					$('.minicart-link .sb-container').scrollBox();
					
				} else {
					$('.minicart-link').removeClass('opened');
					$('.crosssell-recommendation-modal').removeClass('active');
					$('html').removeClass('modal-open');
					$('.mini-cart-products').removeAttr('style');
				}
				if(checkIfRoutine) {
					getCumulativeDiscounts();
				}
			}
		}).fail(function (err) {
			reject(err.error);
		});
	},
	addBonusProduct: function (pid,bliUUID) {
		$('.mini-cart-products .ajax-loader').show();
		
		$.post(util.appendParamsToUrl(Urls.addBonusProductsAJAX, {
			"format": "ajax",
			"pid": pid,
			"bliUUID": bliUUID,
			"minicart": "minicart"
		}), function (data) {
			if (data) {
				$('.minicart').parent('li').html(data);
				attachPromotionClickHandler();
				util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
				minicartCartIconRedirect();
				updateQuantityOnChange();
				minicartRecommendations();
				analyticsEmea.addBonusProductMinicartDataLayer(pid);
				var $minicartLink = $('.minicart-link');
				if (!$minicartLink.hasClass("opened")) {
					$minicartLink.addClass("opened");
					crosssellRecommendationModalHandler();
				}
				$('.minicart-link .sb-container').scrollBox();
			}
		}).fail(function (err) {
			reject(err.error);
		});
	}, 
	addProductFromRecomendation : function (pid, qty, cartAction, prodContainer) {
		$('.mini-cart-products .ajax-loader').show();
		const $data = {
			"format": "ajax",
			"pid": pid,
			"Quantity": qty,
			"cartAction": cartAction,
			"source":'minicartrecomendation'
		}
		$.post(Urls.addProduct, $data, function (data) {
			if (data.error) {
				$('.mini-cart-products .ajax-loader').hide();
				setAddToCartError(data.error, prodContainer);
				
			} else {
				$('.minicart').parent('li').html(data);
				attachPromotionClickHandler();
				util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
				minicartCartIconRedirect();
				updateQuantityOnChange();
				minicartRecommendations();
				const $minicartLink = $('.minicart-link');
				if (!$minicartLink.hasClass("opened")) {
					$minicartLink.addClass("opened");
					crosssellRecommendationModalHandler();
				}
				$('.minicart-link .sb-container').scrollBox();
			}
		}).fail(function (err) {
			reject(err.error);
		});
	},
	crosssellRecommendationModalHandler : crosssellRecommendationModalHandler,
};


/**
 * Loads and displays the "Routine Product Add To Bag Button" button for a routine product via AJAX.
 *
 * This function sends the selected product ID to the server,
 * retrieves the corresponding HTML markup, and injects it into
 * the `.added-routine-product` container without reloading the page.
 */
function getCumulativeDiscounts() {
	const productIds = $(".regimen-all-products").val();
	const pid = $(".regiment-selected-product").val();
	const mainProductId = $('#mainproductid').val();
	const btnAction = $(".regimen-btn-action").val();
	const url = `${$('#getCummulativeDiscountsUrl').val()}`;
	const routineCurrency = $('#routineCurrency').val();
	const isProductAvailable = $('#isProductAvailable').val();
	$.ajax({
		url: url,
		type: 'GET',
		data: {
			productIds: productIds,
			pid: pid,
			mainProductId: mainProductId,
			btnAction: btnAction
		},
		success: function (response) {
			$(".routine-info-text").text(response?.cummulativeDiscounts?.cumulativePromoMsg);
			const items = response?.cummulativeDiscounts?.items;
			const $originalPrice = response?.cummulativeDiscounts?.originalValue;
			const $discountPercentage = response?.cummulativeDiscounts?.discountPercentage;
			const $discountPrice = response?.cummulativeDiscounts?.dicountedPrice;
			const $salesPrice = response?.cummulativeDiscounts?.orderTotalValue;
			const $updateElement = $(".r-top-wrapper");
			const $isCummulativeSameDiscount = response?.cummulativeDiscounts?.isCummulativeSameDiscount;
			//updating todal discount
			if($discountPrice && $discountPrice != 0) {
				$updateElement.find(".r-discount-price").removeClass("visually-hidden");
				if($originalPrice != $salesPrice) {
					$updateElement.find('.r-original-price').text(routineCurrency +''+ $originalPrice).css("display", "inline-block").removeClass("visually-hidden");
				}
				if($discountPercentage != 0) {
					$updateElement.find(".d-percentage-text, .discount-percentage").removeClass("visually-hidden");
					$updateElement.find('.d-percentage-text').text('-' + $discountPercentage).css("display", "inline-block");
				}
				$updateElement.find('.r-discount-price').text(routineCurrency +''+ $salesPrice).css("display", "inline-block");
			}else{
				$updateElement.find(".r-discount-price, .r-original-price, .d-percentage-text, .discount-percentage").addClass("visually-hidden");
			}
			// updating for individual product
			$.each(items, function(index, product) {

				const basePriceVal = (product.basePriceVal ?? 0).toFixed(2);
				const adjustedPriceVal = (product.adjustedPriceVal ?? 0).toFixed(2);
				const productDiscount = product.discount ?? 0;
				if(product.discount > 0) {
					$(".routine-std-price-"+product.productId).text( basePriceVal).css("text-decoration", "line-through");
					$(".routine-sales-price-"+product.productId).text(adjustedPriceVal).css("display", "inline-block");
					$(".discount-percentage-text-"+product.productId).text(productDiscount).css("display", "inline-block");
				} else {
					$(".routine-std-price-"+product.productId).text(basePriceVal).css("text-decoration", "none");
					$(".routine-sales-price-"+product.productId).text(adjustedPriceVal).css("display", "none");
					$(".discount-percentage-text-"+product.productId).text(productDiscount).css("display", "none");
				}
			});
			if(!btnAction) {
				$(".routine-std-price-"+pid).css("text-decoration", "none");
				$(".routine-sales-price-"+pid).css("display", "none");
				$(".discount-percentage-text-"+pid).css("display", "none");
			}
		},
		error: function (xhr, status, error) {
			console.error('Error loading cumulative discounts:', error);
		}
	});
}

/**
 * Global add to cart
 */
$('.global-add-to-cart').on( 'click', function () {
	var _this = $(this);
	var skuData = _this.data('sku');
	minicart.addProduct({
		pid: skuData
	});
});

$('.minicart-link').on('click', function (e) {
	var $minicartLink = $('.minicart-link');
	if ($(window).width() > 991){
		$('.minicart').removeAttr('style');
		if ($('.minicart-link .sb-container .sb-content').length === 0) {
			$('.minicart-link .sb-container').scrollBox();
		} else {
			$('.minicart-link .sb-container .sb-content').removeAttr('style');
			$(window).trigger('resize.scrollBox');
		}
	$minicartLink.find('.minicart').removeClass('closed').addClass("opened"); // minicart slide panel open
	crosssellRecommendationModalHandler();
	util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
	minicartCartIconRedirect();
	}
	($(window).width() > 991 && !$('.pt_cart').length) && $('html').addClass('modal-open');
	checkemptyBonus();
	minicartRecommendations();
});

const setAddToCartError = function (msg, $form) {
	let $errEle = $form.find("#a2c-error");
	let $errEleSticky = $form.find("#a2c-error-sticky");
	let $quickviewError = $form.closest('.product-content').find('.add-to-cart-sticky #a2c-error-quickview');
	const isQuickShopOpen = $('#quick-shop-panel').hasClass('opened');
	if (isQuickShopOpen) {
		$quickviewError.addClass('active');
		$errEle = $quickviewError;
	}

	$errEle.html(msg).slideDown('fast', function () {
		setTimeout(function () {
			$errEle.slideUp(500, function () {
				$(this).removeClass('active');
			});
		}, 2000);
	});

	$errEleSticky.html(msg).slideDown('fast', function () {
		setTimeout(function () {
			$errEleSticky.slideUp(500);
		}, 2000);
	});
};

$(document).on('click', '.remove-link .icon-close', function () {
	var $minicartLink = $('.minicart-link'),
		dataPID = $(this).data('pid');
	if (!$minicartLink.hasClass("opened")) {
		$minicartLink.addClass("opened");
		crosssellRecommendationModalHandler();
	}
	minicart.remove($(this).data('pid'));

	var storedProductIds = JSON.parse(localStorage.getItem('storedproductid')) || [];
	storedProductIds = storedProductIds.filter(id => id != dataPID);
	localStorage.setItem('storedproductid', JSON.stringify(storedProductIds));

	if ($('.pt_cart').length) { // remove product on cart page - sync between minicart and cart 
		$(".user-action-remove button").filter('[data-pid="'+ dataPID +'"]').addClass('remove-cart-item');
		$(".cart-row .remove-cart-item").trigger('click');
	}
	// push event to datalayer when minicart panel closed (only mobile)
	if (!$minicartLink.find("#minicart").hasClass("opened")) {
		analytics.minicartPanelClosed();
		if(localStorage.cartModalOpen === 'miniCartOpen') {
			analytics.cartModalClose();
			localStorage.removeItem('cartModalOpen');
		}
	}
}).on('click', '.minicart-close', function (e) {
	var $minicartLink = $('.minicart-link');
	if ($minicartLink.hasClass("opened")) {
		$minicartLink.removeClass("opened");
		$('.crosssell-recommendation-modal').removeClass('active');
	}
	$minicartLink.find('.minicart').removeClass("opened").addClass('closed'); // minicart slide panel close
	$minicartLink.find('.minicart').removeClass("qtyopenedupdate").addClass('closed'); // minicart slide panel close
	$('.crosssell-recommendation-modal').removeClass('active');
	$('html').removeClass('filter-open');
	$('html').removeClass('modal-open');
	$('.mini-cart-products').removeAttr('style');
	if($('.nav-redesign').length  && $(window).width() < 991) {
		$('.logo-shiseido .header-logo-default').show();
	}
	// push event to datalayer when minicart panel closed (only mobile)	
	if (!$minicartLink.find("#minicart").hasClass("opened")) {
		analytics.minicartPanelClosed();
		if(localStorage.cartModalOpen === 'miniCartOpen') {
			analytics.cartModalClose();
			localStorage.removeItem('cartModalOpen');
		}
	}
}).on('click', '.minicart-overlay', function(){
	$('.minicart-link .minicart-close').trigger('click');
	$('html').removeClass('modal-open');
	$('.mini-cart-products').removeAttr('style');
	$('.minicart-promotion-content') && $('.minicart-promotion-content').removeClass('active');
}).on('click', '.minicart-promotion-threshold-full', function(){
	const $this = $(this); // Cache the selector
	const pid = $this.data('pid');
	const bliUUID = $this.data('bliuuid');

	if (pid) {
		minicart.addBonusProduct(pid, bliUUID);
		checkemptyBonus();
		$('.minicart-link .sb-container').scrollBox();
	}
}).on('click', '.minicart-link #cart-link', function(){
	analyticsEmea.minicartProductList();
	minicartRecommendations().then(() => {
		util.getTrulyVisibleSlides($('.minicart-recommendation-container')).then(() => {
			analytics.minicartCrossSellProductList();
		});
	});
}).on('click', '.minicart-bonus-header .icon-close-modal', function(e){
	$('.minicart-promotion-content').removeClass('active').addClass('closed');
}).on('click', '.minicart-promotion-content.bonus-sample-selection .product-tile-wrapper', function(e){ // Handles the selection of a sample product tile in the minicart. 
	/* 
	* This function prevents the default event action and manages the UI state
	* for selecting a product tile within the minicart. It toggles the 'selected'
	* class on the product tile, updates the count display, and enables or disables
	* the bonus content wrapper based on the selection state. It also updates the
	* threshold input value with the product ID of the selected tile.
	*/

	e.preventDefault();
	const $this = $(this);
	const $multiSelectForm = $this.parents('form');
	const $btn = $this.find('button.multiselect');
	const $thresholdInput = $multiSelectForm.find('input#pids');
	const $productTileWrapper = $this.closest('.product-tile-wrapper');
	const $bonusContentWrapper = $('.bonus-content-wrapper').find('.bonus-footer');
	const $bonusSampleSelection = $('.bonus-sample-selection');
	const selectedCount = $multiSelectForm.find('button[value="selected"]').length;
	const cartButton = $thresholdInput.data('button');
	const selectedProductList = [];
	let limitCount = window.Constants.MAX_BONUS_ITEMS;

	const $promoTileWrapper = $('.minicart-promotion-content .product-tile-wrapper');

	// do checking to compare if limit is met
	let btnIsSelected = $btn.val() === 'selected';

	$bonusSampleSelection.addClass('bonus-sample-selection-redesign');

	if (limitCount === 1) {
		if (!$this.hasClass('product-tile-selected')) {
			$promoTileWrapper.removeClass('product-tile-selected');
			$productTileWrapper.addClass('product-tile-selected');
			$('.count-update').html('1');
			$bonusContentWrapper.removeClass('disabled');
			$bonusContentWrapper.find('.add-to-cart').prop('disabled', false);
			$thresholdInput.val($this.find('.add-to-cart').data('pid'));
		} else {
			$promoTileWrapper.removeClass('product-tile-selected');
			$('.count-update').html('0');
			$bonusContentWrapper.addClass('disabled');
			$bonusContentWrapper.find('.add-to-cart').prop('disabled', true);
			$thresholdInput.val('');
		}
	} else {
		// Helper function to update bonus action state
		function updateBonusAction(selectedCount, selectedLimit) {
			if (selectedCount > 0) {
				$bonusContentWrapper.removeClass('disabled');
				$bonusContentWrapper.find(`button.${cartButton}`).removeAttr('disabled');
			} else {
				$bonusContentWrapper.addClass('disabled');
				$bonusContentWrapper.find(`button.${cartButton}`).attr('disabled', 'true');
			}
			$multiSelectForm.find(".count-update").html(selectedCount <= selectedLimit ? selectedCount : selectedLimit);
		}

		// Dedicated function to toggle selection
		function toggleSelection($btn, $productTileWrapper, isSelected) {
			$btn.toggleClass('remove');
			$btn.val(isSelected ? 'selectable' : 'selected');
			if (isSelected) {
				$productTileWrapper.removeClass('product-tile-selected');
			} else {
				$productTileWrapper.addClass('product-tile-selected');
			}

			// fetch all items that are selected
			$multiSelectForm.find('button[value="selected"]').each(function (index, item) {
				selectedProductList.push($(item).data('pid'));
			});

			// store all selected products to hidden input
			$thresholdInput.val(selectedProductList);

			// update selected counter
			const selectedCounter = parseInt(selectedProductList.length, 10);
			const selectedLimit = parseInt(limitCount, 10);

			updateBonusAction(selectedCounter, selectedLimit);
		}

		if (btnIsSelected || selectedCount < limitCount) {
			toggleSelection($btn, $productTileWrapper, btnIsSelected);
		}
	}

}).on('click', '.mini-cart-crosssell-slot .custom-dd .custom-dd-list-item', function () {
	// Handles the selection of a product tile in the minicart cross sell slot. 
	const $this = $(this);
	const pid = $(this).find('.color-swatch, .swatchanchor').data('pid');
	const targetContainer = $this.parents('.minicart-recommendations-tile');

	const params = {
		format: 'ajax',
		pid: pid,
		templateRender: 'product/minicartcrosssell',
		showswatches: true,
		showpricing: true,
		showpromotion: true,
		isclickable: true,
		showrating: true,
		disablebvseo: true,
		showbrandname: true,
		issliderimage: false,
		source: "MinicartCrosssell",
		isminicartcrosssell: true
	};

	ajax.load({
		url: util.appendParamsToUrl(Urls.transactionalHitTile, params),
		target: targetContainer,
		callback: function () {
			customDropdown.init();
			util.getTrulyVisibleSlides($('.minicart-recommendation-container')).then(() => {
				analytics.minicartCrossSellProductList();
			});
		},
	});
	
}).on('click', '.minicart-recommendations-tile .add-to-cart', function(e){
		const $this = $(this);
		const pid = $this.data('pid');
		const qty = $this.data('quantity');
		const cartAction = $(this).data('cartaction');
		const prodContainer = $this.closest('.product-tile-info');
		minicart.addProductFromRecomendation(pid, qty, cartAction, prodContainer);
}).on('afterChange', '.minicart-recommendations', function () {
	const isMobile = $(window).width() < 1024;
	const $this = $(this);
	const $dd = $this.find('.custom-dd');
	if (isMobile && $dd.hasClass('opened')) {
		$dd.removeClass('opened');
	}
}).on('click', '.obtain-button-container .btn-add-bonus-products-to-cart', function(e) {
	e.preventDefault();
});


function checkemptyBonus() {
	const bonusDiv = document.querySelector(".checkout-products-bonus");
	
	if (bonusDiv && bonusDiv.innerHTML.trim() === "") {
		bonusDiv.classList.add("empty-bonus");
	}

}

// product level bonus modal
function attachPromotionClickHandler() {
	const threshold = $('.minicart-promotion-threshold-full, .minicart-promotion-threshold');
	threshold.parent('.minicart-promotion').addClass('promotion-threshold-active');
	threshold.parents('.mini-cart-footer').addClass('promotion-gwp-active');
	
	$('.minicart-promotion').off('click', '.minicart-promotion-threshold-full').on('click', '.minicart-promotion-threshold-full', function (e) {
		const $this = $(this); // Cache the selector
		const dataHref = $this.data('href');

		if ($this.attr('href') || dataHref) {
			e.preventDefault();
			e.stopPropagation();
			bonusProductsView.show($this.attr('href') ? $this.attr('href') : dataHref);
			checkemptyBonus();
		}
	});
}
	
function minicartCartIconRedirect() {
	if ($(window).width() > 991 && !$('.pt_cart').length) {
		$('.minicart-link #cart-link').on('click', function(e){
			if($('.minicart-link .cart-count').html() > 0 ) {
				e.preventDefault();
			}
		});
	}

	setTimeout(() => {
		const footerHeight = $('.mini-cart-footer').outerHeight();
		const HeaderHeight = $('.mini-cart-header').outerHeight();
		const messageHeight = $('.incentive-message-container').outerHeight() || 0;
		
		$('.mini-cart-products').css({
			'margin-bottom': footerHeight,
			'max-height': ($(window).outerHeight() - (HeaderHeight + footerHeight + messageHeight + 21)),
			'min-height': ($(window).outerHeight() - (HeaderHeight + footerHeight + messageHeight + 21)),
		});

		const $minicartScrollBox = $('.minicart-link .sb-container');
		$minicartScrollBox.find('.sb-content').removeAttr('style');
		$minicartScrollBox.trigger('resize.scrollBox');
	}, 500);
}

function syncQtyDropdownValue($dropdownElem) {
	$dropdownElem.on('selectmenuchange change', function (e) {
		var dataPID = $(this).parents('.mini-cart-product').data('pid');
		var dataRedirectUrl = $(this).parents('.mini-cart-product').data('redirecturl');
		$(this).val($(this).val());
		$(this).selectmenu({
			positionOptions: {
				collision: 'none'
			}
		}).selectmenu('refresh');
		minicart.updateProduct({Quantity : Math.trunc($(this).val()), pid : dataPID, dataRedirectUrl : dataRedirectUrl});
	});


	$('.minicart-Pricing-wrapper #minicart-quantity-button').on('click', function (e) {
		$('.mini-cart-product').removeAttr('style');
		$(this).closest('.mini-cart-product').css('z-index', 2);
	});
}

function updateQuantityOnChange() {
	var $quantityDropdown = $('.minicart-quantity-dropdown')
	$quantityDropdown.selectmenu({
		positionOptions: {
			collision: 'none'
		}
	});
	syncQtyDropdownValue($quantityDropdown);
	checkemptyBonus();
}

function screenResizeHandler() {
	var winWidth = $(window).width();
	$(window).on('resize orientationchange', function () {
		if ($(window).width() != winWidth) {
			winWidth = $(window).width();      
			!$('.minicart-link .minicart').hasClass('opened') && $('html').removeClass('modal-open');
			crosssellRecommendationModalHandler();
		}
	})
}

/**
 * @function crosssellRecommendationModalHandler
 * @description Manages the cross-sell recommendations modal. Waits for the recommendations container, activates the modal if the minicart is open, initializes a Slick carousel on desktop when more than three tiles exist, and triggers PLP slider initialization.
 * @returns {void}
 */
function crosssellRecommendationModalHandler() {
	const $modal = $('.crosssell-recommendation-modal');
	if ($modal.length === 0) {
		return;
	}

	util.waitForElement('.crosssell-recommendation-modal .crosssell-recommendations').then(function ($recommendations) {
		const $productSlickTrack = $('.crosssell-recommendation-modal .product-slick-track');
		if ($('.minicart-link').find('.minicart').hasClass('opened')) {
			$modal.addClass('active');
			analytics.gymsharkCrosssellafterInit($modal.find('.crosssell-recommendations'));
			// Fix: trigger slick to recalculate widths after modal is visible
			setTimeout(function () {
				if ($recommendations.hasClass('slick-initialized')) {
					$recommendations.slick('setPosition');

					$productSlickTrack.each(function () {
						$(this).slick('setPosition');
					});
				}
			}, 100); // slight delay to ensure visibility
		}
		if (
			!$recommendations.hasClass('slick-initialized') &&
			$(window).width() > 767 &&
			$recommendations.find('.crosssell-recommendations-tile').length > 3
		) {
			$recommendations.slick({
				initialSlide: 0,
				autoplay: false,
				dots: false,
				arrows: true,
				infinite: false,
				speed: 150,
				slidesToShow: 3,
				slidesToScroll: 3,
				fade: false,
				cssEase: 'linear',
				nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
				prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>',
			});
			
			// Also call setPosition after initialization
			setTimeout(function () {
				$recommendations.slick('setPosition');
			}, 100);
		}

		// Initialize PLP slider for cross-sell products
		if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
			initPLPSlider();
		}
		setTimeout(function () {
			$productSlickTrack.each(function () {
				$(this).slick('setPosition');
			});
		}, 100);

	}).finally(function () {
		$modal.find('.tile-loader').hide();
		$modal.find('.crosssell-recommendations').css('visibility', 'visible');
	});
}

var initPLPSlider = function () {
	// for each loop to initialize slider
	const isDesktop = window.matchMedia("(min-width: 1025px)").matches;
	$('.crosssell-recommendation-modal .product-slick-track').each(function () {
		let slider = $(this);
		if(!$(this).hasClass("slick-initialized")) {
			$(slider).slick({
				initialSlide: 0,
				autoplay: false,
				dots: false,
				arrows: true,
				infinite: false,
				speed: 150,
				slidesToShow: 1,
				fade: true,
				cssEase: 'linear',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
						arrows: false,
						dots: true,
						}
					}
				]
			});
		}// Initialize the Slick slider
		
		let timer;
		let manualNavigation = false;

		$(slider).on({
			/**
			 * If the user has not manually navigated, shows the second slide after a delay.
			 *
			 */
			mouseenter: function () {
				clearTimeout(timer);

				// If the user has not manually navigated, show the second slide
				if (manualNavigation !== true && isDesktop) {
					var currentIndex = slider.slick('slickCurrentSlide');
					if (currentIndex !== undefined) {
						timer = setTimeout(function () {
							if (currentIndex === 0) { // If the current slide is the first slide
								slider.slick('slickGoTo', 1); // Show the second slide
							}
						}, 100);
					}
				} 
			},
			mouseleave: function () {
				clearTimeout(timer);

				// If the user has not manually navigated, revert to the first slide
				if (manualNavigation !== true && isDesktop) {
					var currentIndex = slider.slick('slickCurrentSlide');
					if (currentIndex !== undefined) {
						timer = setTimeout(function () {
							if (currentIndex !== 0) { // If the current slide is not the first slide
								slider.slick('slickGoTo', 0); // Show the first slide
							}
						}, 100);
					}
				}
			}
		});

		/**
   * Sets a flag to indicate that the user has manually navigated the slider.
   * This is triggered when the user clicks on a slider arrow.
   */
		$(slider).on('click', '.slick-arrow', function () {
			if ($(this).length) { // Check if the element exists
				manualNavigation = true; // Set manual navigation flag
			}
		});
	});
}

/**
 * Initializes the minicart recommendations carousel and related UI once the container is available.
 *
 * - Waits for `.minicart-recommendation-container .minicart-recommendations`.
 * - Applies Slick with configured options and responsive behavior; skips if already initialized.
 * - Initializes custom dropdowns and updates minicart layout/cart icon behavior.
 */
const minicartRecommendations = function () {
	return new Promise(function (resolve, reject) {
		util.waitForElement('.minicart-recommendation-container .minicart-recommendations')
			.then(function ($recommendations) {
				// If Slick is already initialized
				if ($recommendations.hasClass('slick-initialized')) {
					customDropdown.init();
					minicartCartIconRedirect();
					analytics.minicartCrossSellafterInit($recommendations);
					resolve($recommendations);
				} else {
					// Initialize Slick
					$recommendations.slick({
						initialSlide: 0,
						autoplay: false,
						dots: false,
						arrows: true,
						infinite: false,
						speed: 150,
						slidesToShow: 1,
						fade: false,
						cssEase: 'linear',
						nextArrow: '<div class="slick-next"><i class="icon icon-rightCarrot"></i></div>',
						prevArrow: '<div class="slick-prev"><i class="icon icon-leftCarrot"></i></div>',
						responsive: [
							{
								breakpoint: 1024,
								settings: {
									arrows: false,
									dots: true,
									centerMode: true,
									variableWidth: true
								}
							}
						]
					});

					// Use a timeout fallback in case init event doesn't fire
					let resolved = false;

					$recommendations.one('init', function () {
						if (!resolved) {
							resolved = true;
							customDropdown.init();
							minicartCartIconRedirect();
							analytics.minicartCrossSellafterInit($recommendations);
							resolve($recommendations);
						}
					});

					// Fallback: resolve after a small delay anyway
					setTimeout(function () {
						if (!resolved) {
							resolved = true;
							customDropdown.init();
							minicartCartIconRedirect();
							analytics.minicartCrossSellafterInit($recommendations);
							resolve($recommendations);
						}
					}, 100);
				}
			})
			.catch(function (err) {
				console.warn('Error in minicartRecommendations:', err);
				reject(err);
			});
	});
};

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
	
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
	
	return elementBottom > viewportTop && elementTop < viewportBottom;
};


attachPromotionClickHandler();
updateQuantityOnChange();
minicartCartIconRedirect();
screenResizeHandler();

export default Object.assign(minicart, {
	crosssellRecommendationModal: crosssellRecommendationModalHandler
});
